import { render, staticRenderFns } from "./fccAbaClassificacao.vue?vue&type=template&id=79c91efa"
import script from "./fccAbaClassificacao.vue?vue&type=script&lang=js"
export * from "./fccAbaClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports